import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MateriaComentarioRespostaService } from '../../../services/materia.comentarioresposta.service';

@Component({
  selector: 'app-materia-comentario-resposta',
  templateUrl: './materia-comentario-resposta.component.html',
  styleUrl: './materia-comentario-resposta.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MateriaComentarioRespostaComponent {
  @Input() id: number;
  materiaComentarioResposta: any;

  constructor(private materiaComentarioRespostaService: MateriaComentarioRespostaService){

  }

  ngOnInit() {
    this.getResposta();
  }

  getResposta(){
    this.materiaComentarioRespostaService.getbyId(this.id).subscribe({
      next: (res: any) => {
        this.materiaComentarioResposta = res;
      },
    })
  }

}
